export const classes = {
  grid: 'grid grid-cols-4 gap-x-11 pt-1',
  cell: 'flex flex-col gap-[11px] min-w-0',
  label: 'text-taupe-2 text-[12.5px] font-semibold',
  valueRow: 'flex items-baseline gap-[9px] flex-wrap min-w-0 min-h-[27px]',
  value:
    'text-taupe-3 text-[27px] font-extrabold tracking-tight leading-none whitespace-nowrap',
};
